<template>
  <div class="thanks">
    <div class="content">
      <img loading="lazy" src="@/assets/images/ActExpo/Thanks/bolt_branding.svg?external" alt="Bolt Logo." />
      <h1>Thank you!</h1>
      <router-link :to="{ name: 'own-a-network-en' }" class="button fixed-button">Learn More</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Thanks',
  metaInfo: {
    title: 'Thank You | Electrify America',
    meta: [{ name: 'robots', content: 'noindex' }],
  },
};
</script>

<style scoped lang="scss">
.thanks {
  padding: 43px 20px 293px 20px;
  text-align: center;
  @media screen and (max-width: 768px) {
    padding-bottom: 100px;
  }
  h1 {
    font-weight: normal;
    font-size: 48px;
    color: $c-primary;
    letter-spacing: 2.4px;
    margin: 0;
  }
  .button {
    font-size: 14px;
    font-weight: $fw-medium;
    padding: 14px 70px;
    letter-spacing: 0.7px;
  }
}
</style>
